(ns frontend.ui.component.lp-portal.report.company.financials-chart.controller
  (:require
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.style.theme.core :as theme]))

(defn config->editable-data
  [config]
  {:chart-key      :financials
   :columns        (some->> config
                            :xAxis
                            (mapcat :categories)
                            (vec))
   :data           (->> config
                        :series
                        (mapv (fn [serie]
                                (vec (concat [(:name serie)]
                                             (:data serie))))))
   :y-axis-config  (chart-utils/config->editable-y-axis-data config)
   :tooltip-config (chart-utils/config->editable-tooltip-data config)})

(defn editable-data->raw-data
  [edited-data]
  (let [data (:data edited-data)
        hardcoded-keys [:net-sales :ebitda :ebita]]
    (merge
     {:labels (:columns edited-data)}
     {:series-names (mapv first data)}
     (->> data
          (map-indexed (fn [idx row]
                         (let [number-data (->> row
                                                rest
                                                (map (fn [item]
                                                       (when (number? item) item)))
                                                vec)]
                           (if-let [key (get hardcoded-keys idx)]
                             [key number-data]
                             (js/console.warn "Cannot resolve data " row)))))
          (into {})))))

(defn company-financials
  [{:keys [labels y-axis-config tooltip-config ebitda net-sales ebita series-names]}]
  (let [y-axis-1 (chart-utils/resolve-editable-axis-data (first y-axis-config) chart-utils/axis-meur-formatter-no-division "Net sales")
        y-axis-2 (chart-utils/resolve-editable-axis-data (second y-axis-config) chart-utils/axis-meur-formatter-no-division "EBITA EBITDA")
        series-name-1 (chart-utils/resolve-series-name (first series-names) "Net sales")
        series-name-2 (chart-utils/resolve-series-name (second series-names) "EBITDA")
        series-name-3 (chart-utils/resolve-series-name (last series-names) "EBITA")
        tooltip-1 (chart-utils/resolve-editable-tooltip-data (first tooltip-config) chart-utils/meur-formatter)
        tooltip-2 (chart-utils/resolve-editable-tooltip-data (second tooltip-config) chart-utils/meur-formatter)
        tooltip-3 (chart-utils/resolve-editable-tooltip-data (last tooltip-config) chart-utils/meur-formatter)
        ebita? (boolean (some number? ebita))]
    {:chart       {:zoomType "xy"}
     :xAxis       [{:categories    labels
                    :lineColor     (theme/color [:chart :x-axis :line])
                    :gridLineColor (theme/color [:chart :x-axis :grid-line])}]
     :yAxis       [{:title         {:text (:title-text y-axis-1)}
                    :softMin       0
                    :softMax       0
                    :labels        {:formatter (:formatter-fn y-axis-1)}
                    :lineColor     (theme/color [:chart :y-axis :line])
                    :gridLineColor (theme/color [:chart :y-axis :grid-line])}
                   {:title         {:text (:title-text y-axis-2)}
                    :softMin       -4
                    :softMax       4
                    :opposite      true
                    :labels        {:formatter (:formatter-fn y-axis-2)}
                    :lineColor     (theme/color [:chart :y-axis :line])
                    :gridLineColor (theme/color [:chart :y-axis :grid-line])}]
     :colors      (or (util/custom-colors)
                      (util/gradient-colors [:lp-report :chart :bar :gradient-start]
                                            [:lp-report :chart :bar :gradient-end]
                                            3))
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :shared          true}
     :plotOptions {:line {:marker {:enabled false}}}
     :series      [{:name    series-name-1
                    :type    "column"
                    :data    net-sales
                    :tooltip {:outside         true
                              :useHtml         true
                              :backgroundColor (theme/color [:page-bg :bg])
                              :style           {:opacity         1
                                                :backgroundColor (theme/color [:page-bg :bg])}
                              :pointFormatter  (:formatter-fn tooltip-1)}}
                   {:name    series-name-2
                    :type    "line"
                    :data    ebitda
                    :yAxis   1
                    :tooltip {:outside         true
                              :useHtml         true
                              :backgroundColor (theme/color [:page-bg :bg])
                              :style           {:opacity         1
                                                :backgroundColor (theme/color [:page-bg :bg])}
                              :pointFormatter  (:formatter-fn tooltip-2)}}
                   {:name         series-name-3
                    :type         "line"
                    :data         ebita
                    :visible      ebita?
                    :showInLegend ebita?
                    :yAxis        1
                    :tooltip      {:outside         true
                                   :useHtml         true
                                   :backgroundColor (theme/color [:page-bg :bg])
                                   :style           {:opacity         1
                                                     :backgroundColor (theme/color [:page-bg :bg])}
                                   :pointFormatter  (:formatter-fn tooltip-3)}}]}))

